export default "__VITE_ASSET__ca7ee954__"